module.exports = __webpack_public_path__ + "review.03b34857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/review.png
// module id = 359
// module chunks = 0